import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'validUrl'})
export class ValidUrlPipe implements PipeTransform {
  transform(value: any): string | null {
    if (typeof value !== 'string') {
      return null;
    }
    const url = value.trim();
    if (!url) {
      return null;
    }
    try {
      const parsed = new URL(url);
      return (parsed.protocol === 'http:' || parsed.protocol === 'https:') ? url : null;
    } catch (e) {
      return null;
    }
  }
}
